/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CompanyChangeEmail model module.
 * @module model/CompanyChangeEmail
 * @version v1
 */
class CompanyChangeEmail {
    /**
     * Constructs a new <code>CompanyChangeEmail</code>.
     * Change email
     * @alias module:model/CompanyChangeEmail
     */
    constructor() { 
        
        CompanyChangeEmail.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompanyChangeEmail</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompanyChangeEmail} obj Optional instance to populate.
     * @return {module:model/CompanyChangeEmail} The populated <code>CompanyChangeEmail</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompanyChangeEmail();

            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('new_email')) {
                obj['new_email'] = ApiClient.convertToType(data['new_email'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} password
 */
CompanyChangeEmail.prototype['password'] = undefined;

/**
 * @member {String} new_email
 */
CompanyChangeEmail.prototype['new_email'] = undefined;






export default CompanyChangeEmail;

